import { ApplicationError } from '@nzyme/logging/ApplicationError.js';
/**
 * Error thrown by the actor system.
 *
 * This error is primarily used for narrowing and tagging actor-related failures.
 * It extends ApplicationError and does not add additional typed data beyond the base
 * error data dictionary.
 */
export class ActorError extends ApplicationError {
    /**
     * Creates a new ActorError.
     *
     * @param message - The error message.
     * @param data - Additional error data.
     */
    constructor(message, data = {}) {
        super(message, data);
        this.name = 'ActorError';
    }
}
//# sourceMappingURL=ActorError.js.map